import { useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { useQuery, useMutation } from '@apollo/client';
import Banner from '../components/Banner';
import Button from '../components/Button';
import Global from '../components/Global';
import Loader from '../components/Loader';
import { Modal, ModalExit, ModalName, ModalPart } from '../components/Modal';
import Text from '../components/Text';
import { useToast } from '../components/Toast';
import { getHome } from '../utilities/getHome';
import { createSpaceCache } from '../utilities/cache';
import { SPACE_BY_JOIN_CODE } from '../utilities/queries';
import { JOIN_SPACE } from '../utilities/mutations';

const JoinSpaceModal = () => {
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const toast = useToast();
  const { loading, data } = useQuery(SPACE_BY_JOIN_CODE, {
    variables: { joinCode: params.code },
  });
  const [joinSpace] = useMutation(JOIN_SPACE);
  const [spaceExists, setSpaceExists] = useState(true);

  if (!localStorage.getItem('token')) {
    navigate('/login', { state: { from: location }, replace: true });
  }

  return (
    <>
      <Global />
      <Modal onClose={() => getHome(navigate)} closeOnLayerClick={false}>
        {loading ? (
          <ModalPart>
            <Loader />
          </ModalPart>
        ) : (
          <>
            <ModalExit />
            {data && data?.spaceByJoinCode && spaceExists ? (
              <>
                <ModalName>Join</ModalName>
                {data.spaceByJoinCode.bannerUrl && (
                  <Banner
                    src={data.spaceByJoinCode.bannerUrl}
                    alt={data.spaceByJoinCode.name}
                    isAuto={data.spaceByJoinCode.bannerUrl}
                  />
                )}
                <ModalPart>
                  You were invited to join the{' '}
                  <Text isBold>{data.spaceByJoinCode.name}</Text> space.
                </ModalPart>
                <ModalPart>
                  <Button
                    data-autofocus
                    onClick={async () => {
                      try {
                        const data = await joinSpace({
                          variables: { joinCode: params.code },
                          update: (cache, { data: { joinSpace } }) =>
                            createSpaceCache(cache, joinSpace),
                        });
                        navigate(`/s/${data.data.joinSpace.slug}`);
                      } catch (error) {
                        if (
                          error.message ===
                          'You are already a member of this space'
                        ) {
                          navigate(`/s/${data.spaceByJoinCode.slug}`);
                        } else if (error.message === 'Space not found') {
                          setSpaceExists(false);
                        } else {
                          toast({ children: error.message });
                        }
                      }
                    }}
                    isPrimary
                    isExtended
                  >
                    Join
                  </Button>
                </ModalPart>
              </>
            ) : (
              <ModalPart>There is no space with that join code.</ModalPart>
            )}
          </>
        )}
      </Modal>
    </>
  );
};

export default JoinSpaceModal;
